<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->
  <div class="animated fadeIn accelerator-requests" v-if="pageLoaded">
    <!-- loading component -->
    <Loading />
    <b-card style="border: 0" class="mt-0 mb-0">
      <h3>کد فرصت مطالعاتی: {{ proposal.requestsCode }}</h3>
      <h4 class="text-dark">وضعیت فرصت مطالعاتی: {{ proposal.status }}</h4>
      <hr />
      <v-btn
        class="float-end bc-purple"
        v-if="tabIndex == 0"
        @click="saveDocx('doc')"
        elevation="0"
      >
        <i class="fa fa-file-word-o white--text pe-2"></i>
        <span class="white--text text-capitalize">دریافت Word</span>
      </v-btn>
      <b-tabs pills v-model="tabIndex">
        <!-- docx -->
        <div v-show="false" id="doc">
          <div class="all" style="text-align: right">
            <h1
              style="
                display: inline-block;
                text-align: center;
                padding: 5px 0;
                border-bottom: 3px solid black;
              "
            >
              کد فرصت مطالعاتی:
              <span style="direction: ltr; font-family: Bahnschrift SemiBold">{{
                projectControl.requestsCode
              }}</span>
            </h1>
            <div>
              <h2 style="color: black; direction: rtl">
                تاریخ خروجی: {{ exportDate }}
              </h2>
              <hr />
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                عنوان و حمایت‌های پیشین
              </h2>
              <div>
                <ul>
                  <li :class="proposal.faSubject ? 'done' : 'required'">
                    <strong>عنوان دقیق دوره: </strong>{{ proposal.faSubject }}
                  </li>
                  <li
                    :class="proposal.initialIsSupported ? 'done' : 'required'"
                  >
                    <strong
                      >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                      کرده است؟
                    </strong>

                    {{ proposal.initialIsSupported ? "بله" : "خیر" }}
                  </li>

                  <li
                    v-if="
                      proposal.initialIsSupported &&
                      proposal.initialSupportedType != 'other'
                    "
                    :class="proposal.initialSupportedType ? 'done' : 'required'"
                  >
                    <strong> حمایت ها: </strong
                    >{{ proposal.initialSupportedType }}
                  </li>
                  <li
                    v-if="
                      proposal.initialSupportedType == 'other' &&
                      proposal.initialIsSupported
                    "
                    :class="proposal.initialOtherSupport ? 'done' : 'required'"
                  >
                    <strong>عنوان حمایت دریافتی: </strong>
                    {{ proposal.initialOtherSupport }}
                  </li>
                  <li
                    v-if="proposal.initialIsSupported"
                    :class="
                      proposal.initialSupportDescription ? 'done' : 'required'
                    "
                  >
                    <strong>توضیحات حمایت دریافتی: </strong><br />
                    {{ proposal.initialSupportDescription }}
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                اطلاعات اصلی دوره
              </h2>
              <div>
                <ul>
                  <li :class="proposal.faSubject ? 'done' : 'required'">
                    <strong>عنوان به زبان فارسی: </strong
                    >{{ proposal.faSubject }}
                  </li>
                  <li :class="proposal.enSubject ? 'done' : 'required'">
                    <strong>عنوان به زبان انگلیسی: </strong
                    >{{ proposal.enSubject }}
                  </li>
                  <li :class="proposal.universityId ? 'done' : 'required'">
                    <strong>دانشگاه محل اجرای دوره: </strong>
                    {{
                      proposal.universityId
                        ? universities.filter(
                            (x) => x.id == proposal.universityId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == proposal.universityId
                            )[0].text
                          : ""
                        : ""
                    }}
                  </li>

                  <li
                    v-if="proposal.universityId == notUniversity"
                    :class="proposal.otherUniversity ? 'done' : 'required'"
                  >
                    <strong>نام دانشگاه: </strong>{{ proposal.otherUniversity }}
                  </li>
                  <li
                    v-if="proposal.mehvarId != notMehvar"
                    :class="proposal.mehvarId ? 'done' : 'required'"
                  >
                    <strong>محور دوره: </strong>
                    {{
                      proposal.mehvarId
                        ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                          ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                              .text
                          : ""
                        : ""
                    }}
                  </li>
                  <li
                    v-if="proposal.mehvarId == notMehvar"
                    :class="proposal.mehvarId ? 'done' : 'required'"
                  >
                    <strong>محور دوره: </strong> سایر محورها
                  </li>
                  <li
                    v-if="proposal.mehvarId == notMehvar"
                    :class="proposal.otherMehvars ? 'done' : 'required'"
                  >
                    <strong>نام محور: </strong>{{ otherMehvars }}
                  </li>
                  <li>
                    <strong>ماهیت دوره: </strong>

                    <ul>
                      <li v-if="proposal.typeStudy">مطالعاتی</li>
                      <li v-if="proposal.typeSystemicDevelopmental">
                        سیستمی و توسعه‌ای
                      </li>
                      <li v-if="proposal.typePractical">کاربردی</li>
                    </ul>
                  </li>
                  <li>
                    <strong>حوزه دوره: </strong>
                    <ul>
                      <li v-if="proposal.zoneMedicine">پزشکی</li>
                      <li v-if="proposal.zoneAgriculture">کشاورزی</li>
                      <li v-if="proposal.zoneEnvironment">محیط زیست</li>
                      <li v-if="proposal.zoneIndustrial">صنعتی</li>
                      <li v-if="proposal.zoneBioComputing">رایانش زیستی</li>
                      <li v-if="proposal.zoneOther">سایر</li>
                    </ul>
                  </li>
                  <li
                    :class="proposal.oppurtunityActions ? 'done' : 'required'"
                  >
                    <strong>
                      گزارش خلاصه اقداماتی که قصد دارید در دانشگاه مقصد در طی
                      دوره انجام دهید: </strong
                    ><br />{{ proposal.oppurtunityActions }}
                  </li>
                  <br />

                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="proposal.oppurtunityAchievements"
                    :fields="achievmentFieldsDoc"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                اطلاعات متقاضی
              </h2>
              <div>
                <ul>
                  <li :class="proposal.researcherName ? 'done' : 'required'">
                    <strong>نام: </strong>{{ proposal.researcherName }}
                  </li>
                  <li
                    :class="proposal.researcherLastName ? 'done' : 'required'"
                  >
                    <strong>نام خانوادگی: </strong
                    >{{ proposal.researcherLastName }}
                  </li>
                  <li :class="proposal.researcherNatCode ? 'done' : 'required'">
                    <strong>کدملی: </strong>{{ proposal.researcherNatCode }}
                  </li>
                  <li :class="proposal.researcherMobile ? 'done' : 'required'">
                    <strong>تلفن همراه: </strong>{{ proposal.researcherMobile }}
                  </li>
                  <li :class="proposal.researcherFax ? 'done' : 'required'">
                    <strong>دورنگار: </strong>{{ proposal.researcherFax }}
                  </li>
                  <li :class="proposal.researcherEmail ? 'done' : 'required'">
                    <strong>پست الکترونیکی: </strong
                    >{{ proposal.researcherEmail }}
                  </li>
                  <li :class="proposal.researcherState ? 'done' : 'required'">
                    <strong>استان: </strong>{{ proposal.researcherState }}
                  </li>
                  <li :class="proposal.researcherCity ? 'done' : 'required'">
                    <strong>شهر: </strong>{{ proposal.researcherCity }}
                  </li>
                  <li
                    :class="
                      proposal.researcherUniversityId ? 'done' : 'required'
                    "
                  >
                    <strong>دانشگاه محل تحصیل: </strong>
                    {{
                      proposal.researcherUniversityId
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == proposal.researcherUniversityId
                            )[0].text
                          : "-"
                        : "-"
                    }}
                  </li>
                  <li
                    :class="
                      proposal.researcherUniversityOther ? 'done' : 'required'
                    "
                    v-if="proposal.researcherUniversityId == notUniversity"
                  >
                    <strong>نام دانشگاه: </strong
                    >{{ proposal.researcherUniversityOther }}
                  </li>
                  <li class="'done'">
                    <strong>دانشگاه محل اشتغال: </strong>
                    {{
                      proposal.researcherUniversityJobId
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityJobId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == proposal.researcherUniversityJobId
                            )[0].text
                          : "-"
                        : "-"
                    }}
                  </li>
                  <li
                    v-if="proposal.researcherUniversityJobId == notUniversity"
                  >
                    <strong>نام دانشگاه: </strong
                    >{{ proposal.researcherUniversityJobOther }}
                  </li>
                  <li :class="proposal.researcherIBAN ? 'done' : 'required'">
                    <strong>شماره شبا: </strong>{{ proposal.researcherIBAN }}
                  </li>
                  <li
                    :class="proposal.researcherBankName ? 'done' : 'required'"
                  >
                    <strong>نام بانک: </strong>{{ proposal.researcherBankName }}
                  </li>
                  <li
                    :class="
                      proposal.researcherUniversityDestination
                        ? 'done'
                        : 'required'
                    "
                  >
                    <strong>دانشگاه مقصد: </strong
                    >{{ proposal.researcherUniversityDestination }}
                  </li>
                  <li
                    :class="
                      proposal.researcherCountryDestination
                        ? 'done'
                        : 'required'
                    "
                  >
                    <strong>کشور مقصد: </strong
                    >{{ proposal.researcherCountryDestination }}
                  </li>
                  <li v-if="proposal.researcherMasterStudent == 'master'">
                    <strong>شاخص Hindex استاد: </strong
                    >{{ proposal.researcherHindex }}
                  </li>
                  <li v-if="proposal.researcherMasterStudent == 'student'">
                    <strong>شاخص Hindex دانشجو: </strong
                    >{{ proposal.researcherHindex }}
                  </li>
                  <li v-if="proposal.researcherMasterStudent == 'student'">
                    <strong>نمره امتحان جامع دانشجو: </strong
                    >{{ proposal.researcherComprehensiveTestMark }}
                  </li>
                  <li v-if="proposal.researcherMasterStudent == 'student'">
                    <strong>تاریخ امتحان جامع دانشجو: </strong
                    ><span style="direction: ltr">{{
                      proposal.researcherComprehensiveTestDate
                    }}</span>
                  </li>
                  <li
                    :class="
                      proposal.researcherPhDThesisSubject ? 'done' : 'required'
                    "
                  >
                    <strong>عنوان طرح رساله دکتری: </strong
                    >{{ proposal.researcherPhDThesisSubject }}
                  </li>
                  <li
                    v-if="proposal.researcherMasterStudent == 'student'"
                    :class="
                      proposal.researcherPhDThesisDefenceDate
                        ? 'done'
                        : 'required'
                    "
                  >
                    <strong>تاریخ تصویب رساله: </strong
                    ><span style="direction: ltr">{{
                      proposal.researcherPhDThesisDefenceDate
                    }}</span>
                  </li>
                  <br />

                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="proposal.researcherArticleISI"
                    :fields="articlesFieldsDoc"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                اطلاعات اساتید
              </h2>
              <div>
                <strong style="color: blue">استاد راهنمای داخلی</strong>
                <ul>
                  <li :class="supervisors[0].name ? 'done' : 'required'">
                    <strong>نام: </strong>{{ supervisors[0].name }}
                  </li>
                  <li :class="supervisors[0].lastName ? 'done' : 'required'">
                    <strong>نام خانوادگی: </strong>{{ supervisors[0].lastName }}
                  </li>
                  <li :class="supervisors[0].natCode ? 'done' : 'required'">
                    <strong>کدملی: </strong>{{ supervisors[0].natCode }}
                  </li>
                  <li :class="supervisors[0].mobile ? 'done' : 'required'">
                    <strong>تلفن همراه: </strong>{{ supervisors[0].mobile }}
                  </li>

                  <li :class="supervisors[0].email ? 'done' : 'required'">
                    <strong>پست الکترونیکی: </strong>{{ supervisors[0].email }}
                  </li>
                  <li :class="supervisors[0].position ? 'done' : 'required'">
                    <strong>سمت: </strong>{{ supervisors[0].position }}
                  </li>

                  <li
                    :class="supervisors[0].universityId ? 'done' : 'required'"
                  >
                    <strong>دانشگاه محل تحصیل: </strong>
                    {{
                      universities.filter(
                        (x) => x.id == supervisors[0].universityId
                      ).length
                        ? universities.filter(
                            (x) => x.id == supervisors[0].universityId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == supervisors[0].universityId
                            )[0].text
                          : "---"
                        : "---"
                    }}
                  </li>
                  <li
                    v-if="supervisors[0].universityId == notUniversity"
                    :class="
                      supervisors[0].universityOther ? 'done' : 'required'
                    "
                  >
                    <strong>نام دانشگاه: </strong
                    >{{ supervisors[0].universityOther }}
                  </li>
                  <li
                    :class="
                      supervisors[0].universityJobId ? 'done' : 'required'
                    "
                  >
                    <strong>دانشگاه محل اشتغال: </strong>
                    {{
                      supervisors[0].universityJobId
                        ? universities.filter(
                            (x) => x.id == supervisors[0].universityJobId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == supervisors[0].universityJobId
                            )[0].text
                          : "-"
                        : "-"
                    }}
                  </li>
                  <li
                    v-if="supervisors[0].universityJobId == notUniversity"
                    :class="
                      supervisors[0].universityJobOther ? 'done' : 'required'
                    "
                  >
                    <strong>نام دانشگاه: </strong
                    >{{ supervisors[0].universityJobOther }}
                  </li>
                  <hr />
                  <strong style="color: blue">استاد راهنمای خارجی</strong>
                  <li :class="advisors[0].name ? 'done' : 'required'">
                    <strong>نام: </strong>{{ advisors[0].name }}
                  </li>
                  <li :class="advisors[0].lastName ? 'done' : 'required'">
                    <strong>نام خانوادگی: </strong>{{ advisors[0].lastName }}
                  </li>
                  <li :class="advisors[0].mobile ? 'done' : 'required'">
                    <strong>تلفن همراه: </strong>{{ advisors[0].mobile }}
                  </li>

                  <li :class="advisors[0].email ? 'done' : 'required'">
                    <strong>پست الکترونیکی: </strong>{{ advisors[0].email }}
                  </li>
                  <li :class="advisors[0].position ? 'done' : 'required'">
                    <strong>سمت: </strong>{{ advisors[0].position }}
                  </li>
                  <li
                    :class="advisors[0].universityOther ? 'done' : 'required'"
                  >
                    <strong>دانشگاه محل تحصیل: </strong>
                    {{ advisors[0].universityOther }}
                  </li>
                  <li :class="advisors[0].lastDegree ? 'done' : 'required'">
                    <strong>آخرین مدرک تحصیلی: </strong>
                    {{ advisors[0].lastDegree }}
                  </li>
                  <li
                    :class="
                      advisors[0].universityJobOther ? 'done' : 'required'
                    "
                  >
                    <strong>دانشگاه محل اشتغال: </strong>
                    {{ advisors[0].universityJobOther }}
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                اطلاعات تجاری‌سازی
              </h2>
              <div>
                <ul>
                  <li
                    :class="
                      proposal.companyId
                        ? proposal.companyId != notCompany
                          ? 'done'
                          : proposal.otherCompanyName
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                  >
                    <strong>نام شرکت دانش بنیان: </strong
                    >{{
                      proposal.companyId != notCompany
                        ? proposal.companyName
                        : proposal.otherCompanyName
                    }}
                  </li>
                  <li
                    :class="
                      proposal.companyId
                        ? proposal.companyId != notCompany
                          ? 'done'
                          : proposal.otherCompanyRegistrationNumber
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                  >
                    <strong>شماره ثبت شرکت: </strong
                    >{{
                      proposal.companyId != notCompany
                        ? proposal.companyRegistrationNumber
                        : proposal.otherCompanyRegistrationNumber
                    }}
                  </li>
                  <li
                    :class="
                      proposal.companyId
                        ? proposal.companyId != notCompany
                          ? 'done'
                          : proposal.otherCompanyNationalId
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                  >
                    <strong>شناسه ملی شرکت: </strong
                    >{{
                      proposal.companyId != notCompany
                        ? proposal.companyNationalId
                        : proposal.otherCompanyNationalId
                    }}
                  </li>
                  <li :class="proposal.companyProducts ? 'done' : 'required'">
                    <strong>معرفی فناوری یا محصولات شرکت: </strong><br />
                    {{ proposal.companyProducts }}
                  </li>
                  <li
                    :class="proposal.companyContactInfo ? 'done' : 'required'"
                  >
                    <strong>آدرس پستی / شماره تماس/ پست الکترونیک شرکت: </strong
                    ><br />
                    {{ proposal.companyContactInfo }}
                  </li>
                  <li
                    :class="proposal.companyDescription ? 'done' : 'required'"
                  >
                    <strong>توضیحات: </strong><br />
                    {{ proposal.companyDescription }}
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                زمان‌بندی دوره
              </h2>

              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.gantData"
                :fields="timeFieldsDoc"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
              </b-table>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                تعهدات
              </h2>
              <div>
                <ul>
                  <li v-if="proposal.promiseArrays[0]">
                    این دوره در مدت زمان اعلام شده انجام می‌گردد و مسئولیت تاخیر
                    در انجام دوره بر عهده مجری می‌باشد. مدت زمان:
                    {{
                      proposal.gantData.length > 0
                        ? (Math.max(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.returnDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          ) -
                            Math.min(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(
                                    x.dispatchDate,
                                    "jYYYY/jMM/jDD"
                                  ).format("YYYY-MM-DD")
                                ).getTime()
                              )
                            )) /
                            3600 /
                            24 /
                            1000 +
                          " روز"
                        : ""
                    }}
                  </li>
                  <li v-if="proposal.promiseArrays[2]">
                    توافق بین دانشگاه و صنعت در خصوص دستاوردهای دوره وجود دارد.
                  </li>
                  <li v-if="proposal.promiseArrays[3]">
                    کلیه اصلاحات در موعد مقرر و طی 2 هفته توسط اینجانب انجام و
                    در سایت بارگذاری می‌گردد.
                  </li>
                  <li v-if="proposal.promiseArrays[4]">
                    دستاوردهای دوره مشخص است و مستندات ارائه شده است.
                  </li>
                  <li v-if="proposal.promiseArrays[5]">
                    بهره‌بردار نهایی دستاوردهای دوره مشخص است و مستندات ارائه
                    شده است.
                    <span v-if="proposal.commercializingType != 'none'">
                      نام بهره‌بردار:
                      <span v-if="proposal.commercializingType == 'company'">{{
                        proposal.companyId == notCompany
                          ? proposal.otherCompanyName
                          : proposal.companyName
                      }}</span>
                      <span v-else>{{
                        proposal.acceleratorId
                          ? accelerators.filter(
                              (x) => x.id == proposal.acceleratorId
                            )[0].text
                          : ""
                      }}</span>
                    </span>
                  </li>
                  <li v-if="proposal.promiseArrays[6]">
                    کلیه گزارش‌ها و خروجی‌ها و دستاوردها در پایان دوره به ستاد
                    زیست فناوری ارسال و تحویل داده می‌شود.
                  </li>
                  <li v-if="proposal.promiseArrays[7]">
                    ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد نمی‌کند و
                    به منزله ثبت درخواست متقاضی است.
                  </li>
                  <li v-if="proposal.promiseArrays[8]">
                    پروپوزال رساله دکتری اینجانب مصوب شده است.
                  </li>
                  <li v-if="proposal.promiseArrays[9]">
                    امتحان جامع با موفقیت سپری شده است
                  </li>
                  <li v-if="proposal.promiseArrays[10]">
                    میزان شاخص (Hindex) اینجانب صحت دارد
                  </li>
                  <li v-if="proposal.promiseArrays[11]">
                    دعوتنامه معتبر از کشور مقصد دریافت شده است.
                  </li>
                  <li v-if="proposal.promiseArrays[12]">
                    کلیه موارد فوق مورد تایید اینجانب
                    {{
                      (proposal.researcherName
                        ? proposal.researcherName
                        : "-") +
                      " " +
                      proposal.researcherLastName
                    }}
                    به عنوان متقاضی و اساتید راهنما می‌باشد.
                  </li>
                </ul>
              </div>
            </div>
            <hr />
          </div>
        </div>
        <!-- docx -->
        <!-- Proposal part -->
        <b-tab title="چکیده طرح" lazy>
          <Opportunity
            :proposal="proposal"
            :universities="universities"
            :mehvars="mehvars"
            :companies="companies"
            :isLoaded="isLoaded"
            :accelerators="accelerators"
          />
        </b-tab>
        <!-- File part -->
        <b-tab title="فایل های تکمیلی">
          <Files :files="proposal.uploadedFiles" :isLoaded="isLoaded" />
        </b-tab>
        <!-- Project Control part -->
        <b-tab title="کنترل پروژه" active>
          <AcceleratorPc
            :acceleratorReport="acceleratorReport"
            :reportFiles="reportFiles"
            :type="'opportune'"
          ></AcceleratorPc>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("./../../components/sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import AcceleratorPc from "../../components/AcceleratorPc.vue";
import Opportunity from "./../../components/AcceleratorOpportunity";
import Files from "./../../components/UploadedFiles";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    Select2, // NOTE (COMPONENT) component of select2 plugin
    AcceleratorPc,
    Opportunity,
    Files,
  },
  data() {
    return {
      reports: [],
      reports2: [],
      pageLoaded: false,
      resFileBusy: false,
      adminViewFileItems: [],
      adminViewFileFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان فایل" },
        { key: "date", label: "تاریخ فایل" },
        { key: "uploadedFile", label: "فایل" },
      ],
      researcherFileItems: [],
      researcherFileFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ فایل" },
        { key: "upload", label: "بارگذاری" },
      ],
      adminFilesItems: [],
      adminFilesFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ فایل" },
        { key: "operation", label: "عملیات" },
      ],
      editClick: false,
      tableBusy: false,
      contractFileFields: [
        { key: "index", label: "ردیف" },
        { key: "showName", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      refFileFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      refFiles: [],
      acceleratorReport: {},
      additionalFiles: {
        contract: { uploadPercentage: 0 },
        report: { uploadPercentage: 0 },
        request: { uploadPercentage: 0 },
      },
      adminReportsItems: [{}],
      adminReportsItems2: [{ status: "", adminpercent: "", adminMessage: "" }],
      tabIndex: 3,
      newReportBusy: false,
      reportSelectedItem: {
        item: [],
        index: 0,
      },
      selectedItem: {
        item: [],
        index: 0,
      },
      uploadedFilesProject: [],
      uploadedFiles: [],
      max: 100,
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "showName", label: "نام فایل" },
        { key: "title", label: "عنوان فایل" },
        { key: "description", label: "توضیحات" },
        { key: "url", label: "دریافت" },
      ],
      reportFileFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "عنوان فایل" },
        { key: "subject", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "url", label: "دریافت" },
      ],
      myFile: {
        isUploaded: false,
        uploadPercentage: 0,
      },
      myReportFile: [
        {
          isUploaded: false,
          uploadPercentage: 0,
        },
        {
          isUploaded: false,
          uploadPercentage: 0,
        },
      ],
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      rev: "",
      options: [
        { value: "registered", text: "ثبت شده" },
        { value: "underSupervision", text: "در دست نظارت" },
        { value: "holdByAdmin", text: "در دست ادمین" },
        { value: "needsCorrection", text: "نیازمند اصلاح" },
        { value: "approved", text: "تایید شده" },
        { value: "declined", text: "لغو" },
        { value: "incompleteFinish", text: "اختتام ناقص", disabled: "true" },
      ],
      secOptions: [
        { value: "registered", text: "ثبت شده" },
        { value: "declined", text: "لغو" },
      ],
      statusOpt: [
        {
          text: "پذیرش علمی-در انتظار ادمین",
          value: "پذیرش علمی-در انتظار ادمین",
          eng: "scientificApproved",
        },
        { text: "درحال انجام", value: "درحال انجام", eng: "ongoing" },
        { text: "اتمام", value: "اتمام", eng: "finished" },
        { text: "اختتام ناقص", value: "اختتام ناقص", eng: "incompleteFinish" },
      ],
      refereeItems: [],
      refereeFields: [
        { key: "index", label: "ردیف" },
        { key: "refereeId", label: "ناظر" },
        { key: "judge", label: "وضعیت" },
        { key: "judgePer", label: "درصد پیشرفت" },
        { key: "judgeDescription", label: "توضیحات" },
      ],
      researcherItems: [],
      researcherFields: [
        { key: "index", label: "ردیف" },
        { key: "subject", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "percent", label: "درصد پیشرفت" },
        { key: "description", label: "توضیحات" },
        { key: "url", label: "فایل" },
      ],
      adminFields: [
        { key: "index", label: "ردیف" },
        { key: "subject", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "adminPer", label: "درصد پیشرفت" },
        { key: "adminMessage", label: "توضیحات" },
      ],
      reviewersFields: [],
      reviewersData: "",
      reportsItems: [{ files: [] }],
      reportsFields: [
        { key: "index", label: "ردیف" },
        { key: "subject", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      reportItems: [],
      reportFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      projectControl: [],
      oldData: [],
      expireDisable: false,
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectCause: "",
      rejectOptions: [],
      infoo: "",
      isLoaded: true,
      promises: {},
      eduGradeOptions: [
        "--مقطع را انتخاب کنید",
        "کارشناسی",
        "کارشناسی ارشد",
        "دکتری",
        "دکتری حرفه ای",
      ],
      fileBusy: true,
      selectedStatus: null,
      selectedSituation: "",
      comments: "",
      judgements: [],
      selectedJudgement: {},
      journalsFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "message", label: "پیام" },
        { key: "date", label: "تاریخ" },
      ],
      judgementFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
        { key: "description", label: "توضیحات" },
      ],
      situationsOptions: [
        { id: 2, eng: "registered", text: "ثبت شده" },
        { id: 3, eng: "underSupervision", text: "درحال بررسی" },
        { id: 4, eng: "inReview", text: "در دست داوری" },
        { id: 5, eng: "reviewDone", text: "جمع بندی نظرات داوران" },
        { id: 10, eng: "initialAccept", text: "پذیرش اولیه" },
        // { id: 5, text: "تایید اولیه" },
        { id: 11, eng: "corrected", text: "اصلاح شده" },
        { id: 6, eng: "finalAccept", text: "تایید نهایی" },
        { id: 7, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 8, eng: "rejected", text: "رد شده است" },
        { id: 9, eng: "declined", text: "لغو" },
      ],

      moment: moment,
      ckeckbox: {},
      show: false,
      busy: false,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      serviceItems: [],
      executor: {},
      proposal: {},
      universities: [],
      otherUniversity: "",
      mehvars: [],
      companies: [],
      otherMehvars: "",
      zone: new Array(6).fill(false),
      achievmentitems: [],
      timeitems: [],
      timeFields: [
        { key: "index", label: "ردیف" },
        { key: "dispatchDate", label: "تاریخ اعزام" },
        { key: "duration", label: "مدت زمان دوره" },
        { key: "returnDate", label: "تاریخ برگشت" },
        {
          key: "proposalSubject",
          label: "طرح هایی که در آن شرکت داشته اید",
        },
        { key: "operation", label: "" },
      ],
      timeFieldsDoc: [
        { key: "index", label: "ردیف" },
        { key: "dispatchDate", label: "تاریخ اعزام" },
        { key: "duration", label: "مدت زمان دوره" },
        { key: "returnDate", label: "تاریخ برگشت" },
        {
          key: "proposalSubject",
          label: "طرح هایی که در آن شرکت داشته اید",
        },
      ],
      achievitems: [],
      achievFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد" },
        { key: "operation", label: "" },
      ],
      achievFieldsDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد" },
      ],
      articlesItems: [],
      articlesFields: [
        { key: "index", label: "#" },
        { key: "subject", label: "عنوان" },
        { key: "releaseYear", label: "سال انتشار" },
        { key: "refrence", label: "تعداد ارجاع" },
        { key: "writersName", label: "نام نویسندگان" },
        { key: "magName", label: "نام مجله" },
        { key: "upload", label: "آپلود فایل" },
        { key: "operation", label: "" },
      ],
      articlesFieldsDoc: [
        { key: "index", label: "#" },
        { key: "subject", label: "عنوان" },
        { key: "releaseYear", label: "سال انتشار" },
        { key: "refrence", label: "تعداد ارجاع" },
        { key: "writersName", label: "نام نویسندگان" },
        { key: "magName", label: "نام مجله" },
      ],
      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      drPosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      selectedMehvar: 0,
      fileFilter: "",
      taahol: "",
      DoiItem: [],
      DoiField: [
        { key: "subject", label: "عنوان" },
        { key: "mag", label: "مجله" },
        { key: "if", label: "IF" },
        { key: "year", label: "سال" },
      ],
      inventionItem: [],
      inventionField: [
        { key: "subject", label: "عنوان" },
        { key: "year", label: "سال" },
        { key: "description", label: "توضیحات" },
      ],
      file: null,
      OrgCostItem: [],
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      OrgCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
        { key: "operation", label: "" },
      ],
      deviceCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
      ],
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "operation", label: "" },
      ],
      achievmentFieldsDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      tripCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
      ],
      addFile: {
        fileName: "",
        fileDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      },
      acc: 0,
      otherFiles: new Array(10).fill({
        isUploaded: false,
      }),
      myshow: false,
      newReportSubject: "",
      newReportDate: "",
      supervisors: [
        {
          id: "",
          name: "",
          lastName: "",
          mobile: "",
          natCode: "",
          email: "",
          position: "",
          lastDegree: "",
          UniversityId: "",
          UniversityOther: "",
          UniversityJobId: "",
          UniversityJobOther: "",
          resumeFileId: "",
          resumeFile: "",
        },
      ],
      newSupervisor: {},
      advisors: [
        {
          id: "",
          name: "",
          lastName: "",
          mobile: "",
          email: "",
          position: "",
          lastDegree: "",
          UniversityOther: "",
          UniversityJobOther: "",
        },
      ],
      pcUploadedFiles: [],
      contractName: "",
      resReportFiles: [],
      reportFiles: [],
      contractUrl: "",
      uploadedContract: false,
      reportFile: [],
      reportFinanceFile: [],
      myPcFile: [],
      resContractFile: [],
      accelerators: [],
    };
  },
  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    showProject() {
      let acc = 0;
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            name: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
          acc++;
        })
        .catch((err) => {
          console.log(err);
        });
      ///////////////////////////////////////////////
      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          acc++;
        })
        .catch((err) => {
          console.log(err);
        });
      ///////////////////////////////////////////////
      // getting accelerators
      this.$http
        .post(
          this.baseUrl + "/setad/options/accelerators",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.accelerators = res.data;
          this.accelerators.forEach((x) => {
            x.text = x.name;
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
      /////////////////////////////////////////////
      this.$http
        .post(
          this.baseUrl + "/setad/options/companies",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.companies = res.data;
          this.companies.forEach((x) => {
            x.text = x.name;
          });
          this.companies.push(
            new Object({
              id: this.notCompany,
              text: "سایر شرکت ها",
            })
          );

          acc++;
        })
        .catch((err) => {
          console.log(err);
        });
      //getInfo
      this.$http
        .post(
          this.baseUrl + "/setad/accelerator/report/opportune/getInfo",
          {
            reportId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal = res.data.request;
          this.acceleratorReport = res.data.report;
          this.acceleratorReport.judge = "";
          this.acceleratorReport.judgePercent = "";
          this.acceleratorReport.judgeDescription = "";
          this.reportFiles.push({
            name: "گزارش",
            url: this.acceleratorReport.file,
          }),
            this.acceleratorReport.financeFile
              ? this.reportFiles.push({
                  name: "درخواست مالی",
                  url: this.acceleratorReport.financeFile,
                })
              : "",
            this.acc++;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            // this.busyAll = false;
          }

          setTimeout(() => {
            this.pageLoaded = true;
            this.show = true;
          }, 200);
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.$router.push("/accelerator/pcReports");
        });
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
        this.isLoaded = true;
      }
    }, this.isLoadedTimeOut);
    this.showProject();
  },
};
</script>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
</style>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}

.contract-section {
  .custom-control-inline {
    margin-right: 0 !important;
  }
}
#forceFinishedModal___BV_modal_header_ {
  button {
    margin: -1rem !important;
  }
}

.diabled-textarea {
  color: grey;
  border-radius: 6px;
  padding: 8px 12px;
  width: 100%;
  min-height: 45px;
  position: relative;
  padding-top: 10px;
  background-color: #e4e7ea;
}
</style>
